import { ProductResponse } from '@woolworthsnz/trader-api';

/**
 * Returns whether the product is available for purchase
 * based on the price / quantity and a max quantity being available
 */
export const isProductAvailable = (product?: ProductResponse): boolean =>
	!!product?.price?.salePrice && !!product?.quantity?.max;

export const isProductOutOfStock = (product?: ProductResponse): boolean =>
	product?.availabilityStatus?.toString().toLowerCase() === 'out of stock' && isProductAvailable(product);

export function getFormattedAvailabilityStatus(availabilityStatus: string | undefined): string {
	switch (availabilityStatus?.toLowerCase()) {
		case 'in stock': {
			availabilityStatus = 'In stock';
			break;
		}
		case 'out of stock': {
			availabilityStatus = 'Out of stock';
			break;
		}
	}
	return availabilityStatus === undefined ? '' : availabilityStatus;
}
